module.exports = __webpack_public_path__ + "static/media/tv.7e867111.png";